var i4_Popup = {
  id_prefix: 'i4-popup_',
  class_name: 'i4-popup',
  count: 0,
  key_listener: '',
  zindex: 9080,

  jq_instances: {},

  add: function () {
    var id_name = this.id_prefix + this.count++;

    var popup = $.extend({}, i4_jq_Popup_instance);
    popup.id_name = id_name;
    popup.class_name_base = this.class_name;
    popup.initialize();
    this.jq_instances[id_name] = popup;

    if (this.key_listener === '') {

      this.key_listener = i4_Document_listener.add('keyup', {
        keys: [27],
        callback: (function () {
          this.remove(this.get_top().id_name);
        }).bind(this)
      });
      i4_Document_listener.run();
    }

    return popup;
  },

  remove: function (popup_element) {
	var instance = null;

    instance = this.get(popup_element);

    if (instance) {
      instance.remove();
      delete this.jq_instances[instance.id_name];
    } else {
      throw ('i4_Popup: keine popup instance gefunden');
    }

    if (!this.has_open_popups()) {
      this.remove_all();
    }

  },

  has_open_popups: function () {
    var result = false;

    $.each(this.jq_instances, (function (key, value) {

      var $popup = $('#' + value.id_name);

      if ($popup.length) {
        if ($popup.children().length > 0 && value.is_visible()) {
          result = true;
          return false;
        } else {
          delete this.jq_instances[key];
        }
      } else {
        delete this.jq_instances[key];
      }

    }).bind(this));

    return result;
  },

  remove_all: function () {
    if (this.jq_instances) {
      $.each(this.jq_instances, function (key, value) {
        value.remove();
      });
    }

    this.hide_loader();

    this.instances = {};
    this.count = 0;

    i4_Overlay.remove();

    // remove key listener
    i4_Document_listener.remove(this.key_listener);
    i4_Document_listener.run();
    this.key_listener = '';
  },

  get: function (popup_element) {
    var result = null;
    var popup_id = '';

    if (typeof popup_element == 'string') {
      if ($('#' + popup_element).length) {
        popup_element = $('#' + popup_element);
      }
    }

    if (typeof popup_element != 'string') {
      if ($(popup_element).hasClass(this.class_name)) {
        popup_id = $(popup_element).attr('id');
      } else {
        popup_element = $(popup_element).parents('.' + this.class_name);

        if (popup_element) {
          popup_id = popup_element.attr('id');
        }
      }
    }

    result = this.jq_instances[popup_id];

    return result;
  },

  get_top: function () {
    var result = '';
    var z_index = 0;

    $.each(this.jq_instances, function (key, value) {
      var $popup = $('#' + value.id_name);
      if ($popup.css('zIndex') > z_index) {
        z_index = $popup.css('zIndex');
        result = value;
      }
    });

    return result;
  },

  get_zindex: function () {
    this.zindex++;
    return this.zindex;
  },

  show_loader: function () {
    var loader = $('.i4-popup-loader');
    if (!loader.length) {
      loader = $('<div></div>').
      addClass('i4-popup-loader').
      prepend($('<div></div>').addClass('i4-loader'));

      $('body').prepend(loader);
    }

    var cursor = i4_Document_listener.get_click_position();

    loader.css({
      'left': cursor.left + 'px',
      'top': cursor.top + 'px'
    });

    loader.show();

  },

  hide_loader: function () {
    if ($('.i4-popup-loader').length) {
      $('.i4-popup-loader').hide();
    }
  }
};

var i4_jq_Popup_instance = {
  id_name: 'default_popup_name',
  class_draggable: 'popup_draggable',
  class_name_base: '',
  visible: true,
  popup_child: [],
  layout: {
    left: 0,
    top: 0,
    width: 0,
    height: 0
  },
  option: {},
  selectors: {
    header: '.i4-popup__header',
    content: '.i4-popup__content',
    maximize: '.i4-popup__content--maximize',
    footer: '.i4-popup__footer',
  },

  $instance: null,

  callbacks: {},
  add_callback: function (name, callback) {
    this.callbacks[name].push(callback);
    return this;
  },
  callback: function (name, param) {
    $(this.callbacks[name]).each(function (i, item) {
      item(param);
    });
  },

  add_popup_child: function (child) {
    this.popup_child.push(child);
    return this;
  },
  is_visible: function () {
    return this.visible;
  },

  set_option: function (option) {
    this.option = $.extend(this.option, option);
    return this;
  },

  initialize: function () {
    // default options
    this.option = {
      loader: false,
      ajax_file: null,
      ajax_param: {},
      ajax_param_string: null,
      position: 'cursor', // cursor, cloned-popup-instance
      class_name: '',
      overlay: true,
      parent_popup: null
    };
    this.callbacks = {
      before_remove: [],
      after_loaded: []
    };

    this.popup_child = [];
    this.visible = true;
  },

  run: function () {

    // create dom and selector caching
    $('body').prepend($('<div></div>').attr('id', this.id_name).addClass(this.class_name_base));
    this.$instance = $('#' + this.id_name);

    if (this.option.class_name) {
      this.$instance.addClass(this.option.class_name);
    }

    this.$instance.hide();

    // to top
    this.top();

    this.$instance.on('click', (function (event) {
      var clickedElement = $(event.target);
      const clickedTagName = clickedElement.prop('tagName').toLowerCase();
      if (!$.inArray(clickedTagName, ['a', 'img', 'button', 'svg', 'use'])) {
        this.top();
      }

    }).bind(this));

    // console.log('this.option.ajax_file', this.option.ajax_file);
    // console.log('this.option.ajax_param', jQuery.isEmptyObject(this.option.ajax_param));

    if (this.option.ajax_file || !jQuery.isEmptyObject(this.option.ajax_param)) {
      this.load_content_ajax();
    }

    return this;
  },

  load_content_ajax: function () {

    if (this.option.overlay) {
      i4_Overlay.show();
      i4_Popup.show_loader();
    }

    var ajax = i4_Ajax.factory();

    if (this.option.ajax_file) {
      ajax.set_ajax_file(this.option.ajax_file);
    }

    var param_string = jQuery.param(this.option.ajax_param);

    if (this.option.ajax_param_string && this.option.ajax_param_string !== undefined) {
      param_string += '&' + this.option.ajax_param_string;
    }

    ajax.
    set_id(this.id_name).
    set_parameter(param_string).
    set_option({
      on_complete: (function () {

        this.set_layout();
        this.make_draggable();
        this.generate_close_buttons();

        // popup position
        this.position_center();

        this.show();
        i4_Popup.hide_loader();

        // run callbacks
        this.after_content_loaded();
        this.callback('after_loaded', this);


      }).bind(this)
    }).
    run();
  },

  set_content: function (html) {
    this.$instance.html(html);

    this.set_layout();
    this.after_content_loaded();

    return this;
  },

  after_content_loaded: function () {
    if (this.$instance.find('.i4-popup__container--maximized').length > 0) {
      this.maximize();
    }
  },

  show: function () {
    if (this.option.overlay) {
      i4_Overlay.show();
    }

    this.$instance.fadeIn(300);
    this.visible = true;
    return this;
  },

  hide: function () {
    this.$instance.hide();
    this.visible = false;
    return this;
  },

  top: function () {
    var currentIndex = this.$instance.css('zIndex');
    if (currentIndex == 'auto' || currentIndex <= i4_Popup.zindex) {
      this.$instance.css({
        'zIndex': i4_Popup.get_zindex()
      });
    }
    return this;
  },

  set_layout: function () {
    this.layout = {
      left: parseInt(this.$instance.css('left').replace('px', '').replace('auto', '0')),
      top: parseInt(this.$instance.css('top').replace('px', '').replace('auto', '0')),
      width: parseInt(this.$instance.width()),
      height: parseInt(this.$instance.height())
    };
    return this;
  },

  make_draggable: function () {

    if (this.$instance.draggable) {
      this.$instance.draggable({
        handle: '.' + this.class_draggable,
        stop: (function () {
          this.move(this.$instance.css('top').replace('px', ''), this.$instance.css('left').replace('px', ''));
        }).bind(this)
      });

      $('.' + this.class_draggable).css({
        'cursor': 'move'
      });
    }

    return this;
  },

  move: function (top, left) {
    var correction = 20; // 20 px: minimum margin between popup and browser window
    var width = this.$instance.width();
    var height = this.$instance.height();
    var renewSize = false;

    top = parseInt(top);
    left = parseInt(left);

    // popup must be in the window
    // get dimensions
    var viewport_dimension = {
      height: this.get_client_height(),
      width: this.get_client_width()
    };
    var viewport_scroll = {
      top: document.documentElement.scrollTop,
      left: document.documentElement.scrollLeft,
    };

    // check that popup is not bigger than viewport!
    if (width > (viewport_dimension.width - 2 * correction)) {
      width = (viewport_dimension.width - 2 * correction);
      renewSize = true;
    }
    if (height > (viewport_dimension.height - 2 * correction)) {
      height = (viewport_dimension.height - 2 * correction);
      renewSize = true;
    }

    if (renewSize === true) {
      this.renew_size(width, height);
    }

    // check that top, left corner of popup is visible in scrolled viewport!
    if (top < viewport_scroll.top) {
      top = viewport_scroll.top + correction;
    }

    if (left < (viewport_scroll.left + correction)) {
      left = viewport_scroll.left + correction;
    }

    // check that bottom, right corner of popup is visible in scrolled viewport!
    if ((top + height) > (viewport_scroll.top + viewport_dimension.height)) {
      top = viewport_scroll.top + viewport_dimension.height - height + correction;
    }

    if ((left + width) > (viewport_scroll.left + viewport_dimension.width)) {
      left = viewport_scroll.left + viewport_dimension.width - width - correction;
    }

    this.layout.top = top;
    this.layout.left = left;

    this.$instance.css({
      'left': left + 'px',
      'top': top + 'px'
    });

    return this;
  },

  renew_position: function () {
    this.move(this.layout.top, this.layout.left);
  },

  renew_size: function (width, height) {
    this.layout.width = width;
    this.layout.height = height;
    this.$instance.css({
      'width': this.layout.width + 'px',
      'height': this.layout.height + 'px'
    });
  },

  maximize: function () {
    var correction = 20; // 20 px: minimum margin between popup and browser window
    var scrollTop = document.documentElement.scrollTop;
    var scrollLeft = document.documentElement.scrollLeft;
    var width = (this.get_client_width() - 2 * correction);
    var height = (this.get_client_height() - 2 * correction);

    // resize and move the popup
    this.renew_size(width, height);
    this.move(scrollTop + correction, scrollLeft + correction);

    // maximize popup-content
    var $header = this.$instance.find(this.selectors.header);
    var $content = this.$instance.find(this.selectors.content);
    var $maximize = this.$instance.find(this.selectors.maximize);
    var $footer = this.$instance.find(this.selectors.footer);

    if ($content.length > 0 && $maximize.length > 0) {
      // popup sizing
      var ppHeader = $header.length > 0 ? $header.outerHeight() : 0;
      var ppFooter = $footer.length > 0 ? $footer.outerHeight() : 0;
      var ppContent = height - ppHeader - ppFooter;
      var ppContentContentBox = $content.outerHeight() - $content.height();
      ppContent = ppContent - ppContentContentBox;
      $content.height(ppContent);

      // form sizing
      var $formHeader = this.$instance.find('.i4-form__header');
      var $formButtons = this.$instance.find('.i4-form__button-container');
      var $formContent = this.$instance.find('.i4-form__content');

      var formHeader = $formHeader.length > 0 ? $formHeader.outerHeight() : 0;
      var formButtons = $formButtons.length > 0 ? $formButtons.outerHeight() : 0;
      var formContent = ppContent - formHeader - formButtons;
      var formContentContentBox = $formContent.outerHeight() - $formContent.height();
      formContent = formContent - formContentContentBox;
      $formContent.height(formContent);
    }
  },

  generate_close_buttons: function () {
    $('#' + this.id_name + ' .close_popup').on('click', (function (event) {
      event.preventDefault();

      if (this.$instance.find('.mce-container').length && typeof (tinymce) != "undefined") {
        tinymce.remove();
      }

      i4_Popup.remove(this.id_name);
    }).bind(this));

    return this;
  },

  remove: function () {
    if (this.$instance.length) {
      this.callback('before_remove');

      this.$instance.remove();
    }
    this.visible = false;

    if (this.popup_child.length > 0) {
      $(this.popup_child).each(function (i, item) {
        item.remove();
      });
    }

    if (!i4_Popup.has_open_popups()) {
      i4_Overlay.remove();
    }
  },

  position_center: function () {
    // get dimensions
    var popup_width = this.$instance.width();
    var popup_height = this.$instance.height();
    var body_width = this.get_client_width();
    var body_height = this.get_client_height();

    // calculate center of the page
    var top = document.documentElement.scrollTop + Math.floor((body_height - popup_height) / 2);
    var left = Math.floor((body_width - popup_width) / 2);

    this.move(top, left);

    return this;
  },

  get_client_width: function () {
    var width = document.documentElement.clientWidth || document.body.clientWidth || document.documentElement.scrollWidth || document.body.scrollWidth;
    if (!width) {
      width = window.innerWidth - 20; // innerWidth last, correct for scrollbars
    }

    return width;
  },

  get_client_height: function () {
    var height = document.documentElement.clientHeight || document.body.clientHeight || document.documentElement.scrollHeight || document.body.scrollHeight;
    if (!height) {
      height = window.innerHeight - 20; // innerHeight last, correct for scrollbars
    }

    return height;
  }
};

/**
 * kontrolliert den abgedunkelten hintergrund
 */
var i4_Overlay = {
  elementClass: 'i4-popup-overlay',

  show: function () {
    this.$overlay = $('.' + this.elementClass);

    // bg
    if (!this.$overlay.length) {
      this.$overlay = $('<div></div>').addClass(this.elementClass);
      $('body').prepend(this.$overlay);
    }

    this.$overlay.show();
  },

  remove: function () {
    this.$overlay = $('.' + this.elementClass);

    if (this.$overlay.length) {
      this.$overlay.fadeOut(200, () => {
        this.$overlay.remove();
      });
    }
  },
};
